import { Component } from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../decorators'
import { toFHIR, fromFHIR } from '../../../../lib/Proxy/diagnostic'
import * as Card from '../../../shared/card'
import CrudTable from '../../../shared/CrudTable'
import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'
import FriendlyDate from '../../../shared/Date/FriendlyDate'
import ConfirmationDeleteDialog from '../../../shared/DeleteDialog/ConfirmationDeleteDialog'

import DiagnosticForm from './form'

const tableDefinition = [
  {
    title: 'Date Uploaded',
    displayFn: v => <FriendlyDateTime datetime={v.updated_at} />,
    sortBy: 'updated_at'
  },
  {
    title: 'Category',
      displayFn: v => v?.category?.display,
    sortBy: 'category.display'
  },
  {
    title: 'Type',
    displayFn: v => v.type
  },
  {
    title: 'Performed or Collected Date',
    displayFn: v => <FriendlyDate date={v.performed} />,
    sortBy: 'performed'
  },
  {
    title: 'Source',
    displayFn: v => v.source
  },
  {
    title: 'Performer',
    displayFn: v => v.performer
  }
]

class Diagnostics extends Component {
  constructor (props) {
    super(props)

    const patientId = this.props.params.id

    this.urls = {
      get: () =>
        `/patients/${patientId}/fhir/DiagnosticReport/_search?patient=${patientId}&_count=99999`,
      create: () => `/patients/${patientId}/fhir/DiagnosticReport`,
      update: entry =>
        `/patients/${patientId}/fhir/DiagnosticReport/${entry.id}`,
      delete: entry =>
        `/patients/${patientId}/fhir/DiagnosticReport/${entry.id}`
    }
    this.mapFns = {
      toForm: fromFHIR,
      toFhir: entry => toFHIR(entry, patientId)
    }
  }

  render () {
    return (
      <div className='main'>
        <Card.Card>
          <Card.Header>
            <h2>Diagnostic Documents</h2>
          </Card.Header>
          <div style={{ padding: '0 1rem 1rem' }}>
            <CrudTable
              entryType='diagnostic'
              entrySet={this.props.params.id}
              tableDefinition={tableDefinition}
              urlFns={this.urls}
              mapFns={this.mapFns}
              form={DiagnosticForm}
              initialValues={{ mPower: false }}
              additionalFormProps={{
                currentUser: this.props.currentUser,
                clientName: this.props.clientName,
                patientId: this.props.params.id
              }}
              deleteDialog={ConfirmationDeleteDialog}
              additionalDeleteDialogProps={{ prompt: 'Really delete?' }}
              sortOn={0}
              sortDir='desc'
            />
          </div>
        </Card.Card>
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  currentUser: redux.users.current_user,
    clientName: redux?.patient?.clientName
})

export default connect(mapStateToProps)(withLegacyRouter(Diagnostics))
